<script setup>
import { router, Head, useForm } from '@inertiajs/vue3';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import JetApplicationHeader from '@/Jetstream/ApplicationHeader.vue';
import JetApplicationFooter from '@/Jetstream/ApplicationFooter.vue';
import JetWelcomePanel from '@/Jetstream/WelcomePanel.vue';
import AppTheming from '@/Jetstream/AppTheming.vue';
import JetInputError from '@/Jetstream/InputError.vue';

defineProps({
    status: String,
});

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";

const form = useForm({
    email: '',
    urlNamePrefix: urlNamePrefix,
    errors: ''
});

const submit = () => {
    form.post(route(urlNamePrefix+'password.email'));
};
</script>

<template>

    <AppTheming />

    <Head title="Forgot Password" />

    <JetApplicationHeader />

    <div id="content-wrapper">

        <div id="main-content" class="container mx-auto flex flex-col md:flex-row justify-between w-full pt-5 pb-5">

            <div id="col-intro" class="md:w-2/3 md:pr-10 lg:pr-40">
                <JetWelcomePanel />
            </div>
            <div id="col-form" class="md:w-1/3">

                <div class="card sos-programme-form-card p-10 rounded-2xl mt-10">

                    <div class="mb-4 manage-password">
                        {{ $t('application.auth.forgot_password') }}
                    </div>

                    <div v-if="status" class="mb-4 font-bold">
                        {{ status }}
                    </div>

                    <JetValidationErrors class="mb-4"/>
                    <JetInputError :message="form.errors.email ? form.errors.email[0] :''" class="mb-4 col error"/>

                    <form @submit.prevent="submit">
                        <div>
                            <JetLabel for="email" :value="$t('application.auth.email')" />
                            <JetInput
                                id="email"
                                v-model="form.email"
                                type="email"
                                class="mt-1 block w-full"
                                required
                                autofocus
                            />
                        </div>

                        <div class="flex items-center justify-end mt-4">
                            <JetButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                {{ $t('application.auth.email_password') }}
                            </JetButton>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <JetApplicationFooter :programme="programme" :organisation="organisation" />

</template>
